// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"563":"e62830e0","966":"0afdf5d6"}[chunkId] + ".css";
};